import PrivateCardSlider from './PrivateCardSlider';

export default PrivateCardSlider;
